<template>
  <el-dialog
    :title="setId?'编辑病种信息':'新增病种信息'"
    :visible.sync="nameDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center>
    <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
      <el-form-item label="病种名称" prop="name">
        <el-input v-model="accountForm.name" placeholder="请输入病种名称"></el-input>
      </el-form-item>
<!--      <el-form-item label="手机号" prop="phone">-->
<!--        <el-input v-model="accountForm.phone" placeholder="请输入手机号"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="备注" prop="desc">-->
<!--        <el-input type="textarea" v-model="accountForm.desc" placeholder="请输入备注"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

import { saveIllness} from "@/api/service";

export default {
  name: "nameDialog",
  props: {
    nameDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      power: 0,
      accountForm: {
        name: '',

      },
      xiaoqu: [],
      rules: {
        name: [{required: true, message: '请输入病种名称', trigger: 'blur'}],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },

  },
  created() {

  },
  methods: {

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await saveIllness(
        this.accountForm.name,
        this.setId ? this.setId : '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }

  },
  watch: {
    setItem() {
      this.accountForm = {
        name: this.setItem.name,
      };
    },
  }
}
</script>

<style scoped lang="scss">

</style>
